const multiLineRegexp = /\n{2,}/g;
export const processGenerationResult = (text) => text.replace(multiLineRegexp, '<br>');

export const isEditor = window.location.pathname.includes('/documents/');
